import { Card, CardContent, Grid, Typography } from "@mui/material";
import { Product, YearDepositSummaryDTO } from "../../../interfaces/DTO/mislaka_xml_models";
import { formatCurrency } from "../../../utils/namesFormater";

interface ProductYearSummaryProps {
  product: Product;
}

const fieldLabels: Record<keyof YearDepositSummaryDTO, string> = {
  total_employee_contributions: "מתחילת שנה הפקדות עובד",
  total_employer_contributions: " מתחילת שנה הפקדות מעסיק",
  total_compensation_contributions: "מתחילת שנה הפקדות פיצויים",
  end_of_year_balance: " יתרת סוף שנה קודמת",
  surrender_value: "שנה קודמת ערך פדיון",
  paid_up_value: "שנה קודמת ערך חיתום",
  actuarial_adjustment: "איזון אקטוארי",
};

export const ProductDepositsYearSummary: React.FC<ProductYearSummaryProps> = ({ product }) => {
 const flattenSummaries = product.policies_or_accounts.flatMap(pa =>
  Array.isArray(pa.year_deposit_summary)
    ? pa.year_deposit_summary.map((summary, index) => ({
        ...summary,
        policy_number: pa.policy_number,
        key: `${pa.policy_number}-${index}`,
      }))
    : [] // אם year_deposit_summary לא קיים או לא מערך
);

  return (
    <Grid container spacing={2}>
      {flattenSummaries.map((summary) => {
        const filteredFields = Object.entries(summary)
          .filter(
            ([key, value]) =>
              key !== "policy_number" && key !== "key" && typeof value === "number" && value > 0
          );

        if (filteredFields.length === 0) return null;

        return (
          <Grid item xs={12} md={6} key={summary.key} mt={2}>
            <Typography variant="h6">יתרות סוף שנה</Typography>
            <Card>
              <CardContent>
               
                {filteredFields.map(([field, value]) => (
                  <Typography key={field}>
                    {fieldLabels[field as keyof YearDepositSummaryDTO] || field}: {formatCurrency(value as number)}
                  </Typography>
                ))}
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};